module.exports = __webpack_public_path__ + "img/44.ba5102b0.svg";